/** 单据状态文案，与原 workflow.js 一致。审核状态 2 优先显示「已审」。 */
export function workflowStatusText(status, approveStatus) {
  if (String(approveStatus) === '2') {
    return '已审'
  }
  const map = {
    draft: '草稿',
    submitted: '已提交',
    in_approval: '审批中',
    approved: '已通过',
    rejected: '已驳回'
  }
  return map[String(status || 'draft')] || '未审'
}

export function workflowStatusTagType(status, approveStatus) {
  if (String(approveStatus) === '2') {
    return 'success'
  }
  const map = {
    draft: 'info',
    in_approval: 'warning',
    rejected: 'danger',
    approved: 'success'
  }
  return map[String(status || 'draft')] || 'info'
}

export function isWorkflowEditable(workflowStatus, approveStatus) {
  if (String(approveStatus) === '2') {
    return false
  }
  const st = String(workflowStatus || 'draft')
  return st === 'draft' || st === 'rejected'
}

export function normalizeWorkflowDocUi(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }
  const bool = (v) => v === true || v === 'true' || v === 1 || v === '1'
  const hasFlag = ['workflowEnabled', 'definitionMatched', 'inApproval', 'directApproveAllowed', 'submitAllowed']
    .some(k => raw[k] !== undefined && raw[k] !== null)
  if (!hasFlag) {
    return null
  }
  return {
    workflowEnabled: bool(raw.workflowEnabled),
    definitionMatched: bool(raw.definitionMatched),
    inApproval: bool(raw.inApproval),
    directApproveAllowed: bool(raw.directApproveAllowed),
    submitAllowed: bool(raw.submitAllowed)
  }
}

/** 是否允许显示原「审核」（直接终审）按钮 */
export function canShowDirectApproveButton(ui) {
  const norm = normalizeWorkflowDocUi(ui)
  if (!norm) {
    return false
  }
  if (norm.inApproval || norm.submitAllowed) {
    return false
  }
  if (norm.workflowEnabled && norm.definitionMatched) {
    return false
  }
  return norm.directApproveAllowed
}

const WF_TRAIL_STATUS_MAP = {
  pending: '待处理',
  approved: '已通过',
  rejected: '已驳回',
  cancelled: '已取消'
}

const WF_TRAIL_TYPE_MAP = {
  pending: '',
  approved: 'success',
  rejected: 'danger',
  cancelled: 'info'
}

export function formatWorkflowTrailTime(val) {
  if (!val) return ''
  return String(val).slice(0, 19).replace('T', ' ')
}

/** 将流程任务列表转为时间线展示数据，已取消的待办不展示。 */
export function buildWorkflowTimeline(tasks) {
  if (!tasks || !tasks.length) return []
  const trailTime = (t) => {
    const raw = t.actionDate || t.createDate
    return raw ? new Date(raw).getTime() : 0
  }
  return [...tasks]
    .filter(t => t.status !== 'cancelled')
    .sort((a, b) => trailTime(b) - trailTime(a) || String(b.taskId || '').localeCompare(String(a.taskId || '')))
    .map(t => ({
      ...t,
      statusLabel: WF_TRAIL_STATUS_MAP[t.status] || t.status,
      timelineType: WF_TRAIL_TYPE_MAP[t.status] || 'info'
    }))
}

export function resolveWorkflowTrailTasks(workflowInstance, tasks) {
  if (tasks && tasks.length) return tasks
  if (workflowInstance && workflowInstance.tasks) return workflowInstance.tasks
  return []
}

export function shouldShowWorkflowTrail({ inViewMode, workflowInstance, workflowDocUi, workflowDocUiReady }) {
  if (!inViewMode) return false
  if (workflowInstance && workflowInstance.instanceId) return true
  if (!workflowDocUiReady) return false
  const ui = normalizeWorkflowDocUi(workflowDocUi)
  return !!(ui && ui.workflowEnabled)
}
